<section class="loginPage">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="loginPanel">
					<div class="logo">
						<img src="../../assets/img/logo.png" alt="Medicinae">
					</div>
					<div class="actions">
						<!-- Nav tabs -->
						<ul class="nav nav-tabs" role="tablist">
							<li role="presentation" class="active"><a href="#login" aria-controls="login" role="tab" data-toggle="tab">Troca de senha</a></li>
						</ul>

						<!-- Tab panes -->
						<div class="tab-content">
							<div role="tabpanel" class="tab-pane active" id="login">
								<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
									<div class="input-group">
										<input type="password" formControlName="old_password" name="old_password" class="form-control" placeholder="Digite sua senha antiga"
											aria-describedby="basic-addon1">
										<span class="input-group-addon"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
									</div>
                  <div *ngIf="formErrors.old_password" class="alert-danger error-msg black">
                    {{ formErrors.old_password }}
                  </div>
									<div class="input-group">
										<input type="password" formControlName="password" name="password" class="form-control" placeholder="Digite sua nova senha"
											aria-describedby="basic-addon1">
										<span class="input-group-addon"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
									</div>
                  <div *ngIf="formErrors.password" class="alert-danger error-msg black">
                    {{ formErrors.password }}
                  </div>
									<div class="input-group">
										<input type="password" formControlName="password_confirmation" name="password_confirmation" class="form-control" placeholder="Confirme sua nova senha"
											aria-describedby="basic-addon1">
										<span class="input-group-addon"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
									</div>
                  <div *ngIf="formErrors.password_confirmation" class="alert-danger error-msg black">
                    {{ formErrors.password_confirmation }}
                  </div>
                  <div class="form-group row">
										<div class="col-sm-12">
											<div class="alert alert-info" *ngFor="let msg of success">
												{{ msg }}
											</div>
										</div>
                  </div>
                  <div class="form-group row">
										<div class="col-sm-12">
											<div class="alert alert-danger" *ngFor="let err of errors">
												{{ err }}
											</div>
										</div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <!--<button type="submit" class="btn btn-default btn-auth">Enviar</button>-->
                      <loading-button [is-visible]="showLoading" [is-user]="isUser" text="Enviar"></loading-button>
                    </div>
                  </div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>